import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import { errorToast, useToastStore } from "@/shared/ui";
import { coachingQueriesStore, unsubscribeToSession } from "../api";

export const useUnsubscribeToSession = () => {
  const pushToast = useToastStore((state) => state.pushToast);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unsubscribeToSession,
    onSuccess: (session) => {
      const sessionTitle = session.title
        ? t`You've successfully canceled your participation in ${session.title}`
        : "";

      void pushToast({
        type: "success",
        title: t`Success`,
        message: t`Unsubscribed Successfully! ${sessionTitle}`,
      });

      void queryClient.invalidateQueries({
        queryKey: coachingQueriesStore.coaching.patient._ctx.session.queryKey,
      });
    },
    onError: errorToast,
  });
};
